// libs
import React from 'react';
// components
import { AccountSelectPage } from '@/components/AccountSelect';
const Index = () => {
    return React.createElement(AccountSelectPage, null);
};
export default Index;
